//https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
export const CopyText = {
  mounted() {
    this.el.addEventListener("click", this.copyText.bind(this));
  },

  copyText() {
    let text = this.el.dataset.value;
    const type = this.el.dataset.type;
    const successMessage =
      this.el.dataset.successMessage ||
      "The text has been copied to your clipboard";

    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }

    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.pushEvent("set_flash", {
          message: successMessage,
          type: "success",
        });
      })
      .catch((error) => {
        this.pushEvent("set_flash", {
          message: "Error while trying to copy the text to your clipboard",
          type: "error",
        });
      });
  },

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand("copy");
      var msg = successful ? "successful" : "unsuccessful";

      this.pushEvent("set_flash", {
        message: "Copying text command was " + msg,
        type: "info",
      });
    } catch (err) {
      this.pushEvent("set_flash", {
        message: "Error while trying to copy the text to your clipboard",
        type: "error",
      });
    }

    document.body.removeChild(textArea);
  },
};
